import React, { useState } from 'react';
import { Input, DatePicker, message, Modal, Button } from 'antd';
import moment from 'moment';

const EditableCell = ({
  title,
  dataIndex,
  editable,
  children,
  value,
  record,
  handleSave,
  dataType,
  ...restProps
}) => {
  const [editing, setEditing] = useState(false);
  const [inputValue, setInputValue] = useState(value);
  const [datavalue, setDataValue] = useState(false);


  const handleChange = (e) => {
    const input = e.target.value;
    setDataValue(true);
    if (/^\d*$/.test(input)) {
      setInputValue(input);
    } else {
      message.warning('Solo se permiten números.');
    }
  };

  const save = () => {
    const finalValue = /^\d+$/.test(inputValue) ? inputValue : '0';
    if (datavalue && finalValue !== inputValue) {
      message.info('El valor no era válido y se ha restablecido a 0.');
    }
    if (datavalue) {
      setEditing(false);
      handleSave({ ...record, [dataIndex]: finalValue });
    }
  };

  const handleDateChange = (date) => {
    const formattedDate = date ? date.format('YYYY-MM-DD') : '';
    handleSave({ ...record, fechaFinReal: formattedDate });
    setEditing(false);
  };

  const handleEditDate = () => {
    setEditing(true);
    Modal.destroyAll(); // 👈 cerrar el modal al editar
  };

  const handleDeleteDate = () => {
    handleSave({ ...record, fechaFinReal: null });
    setEditing(false);
    Modal.destroyAll(); 
  };

  const confirmEdit = () => {
    Modal.confirm({
  title: 'Confirmar acción',
  content: '¿Qué deseas hacer con este campo de fecha?',
  okText: 'Editar',
  cancelText: 'Cancelar',
  onOk: handleEditDate,
  onCancel: () => setEditing(false),
  maskClosable: true,  // <-- Agregado para cerrar al hacer clic fuera
  ...((!record.fechaFinReal || record.fechaFinReal !== "Sin fecha") && {
    icon: null,
    footer: (_, { OkBtn, CancelBtn }) => (
      <>
        <Button onClick={() => { setEditing(false); Modal.destroyAll(); }}>
          Cancelar
        </Button>
        <Button danger onClick={handleDeleteDate}>
          Eliminar
        </Button>
        <Button type="primary" onClick={handleEditDate}>
          Editar
        </Button>
      </>
    ),
  }),
});

  };

  return (
    <td {...restProps}>
      {editable ? (
        editing ? (
          dataType === 'date' ? (
            <DatePicker
              value={
                value && moment(value, 'YYYY-MM-DD', true).isValid()
                  ? moment(value, 'YYYY-MM-DD')
                  : null
              }
              onChange={handleDateChange}
              autoFocus
            />
          ) : (
            <Input
              value={inputValue}
              onChange={handleChange}
              onBlur={save}
              autoFocus
              inputMode="numeric"
              pattern="\d*"
            />
          )
        ) : (
          <div className="editable-cell-value-wrap" onClick={confirmEdit}>
            {children || 'Sin fecha'}
          </div>
        )
      ) : (
        children || 'Sin fecha'
      )}
    </td>
  );
};

export default EditableCell;
